export default "__VITE_ASSET__EWawiDCk__"